import { Injectable } from '@angular/core';
import { FiBackendService } from '../../../fi-backend/fi-backend.service';
import { LoadingService } from '../../../fi-loading/loading.service';
import {
    IChecklist2ReportAnswer,
    IChecklist2ReportAttentionRequired,
    IChecklist2ReportChecklistSummary,
    IChecklist2ReportChecklistUnits,
    IChecklist2ReportCheckpoints,
    IChecklist2ReportDateRange,
    IChecklistV2ReportParameterFilter,
} from '../shared/fi-checklist2-report';

@Injectable()
export class FiChecklist2ReportOpenChecklistsService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getOpenChecklistsSummary(currentFilter: IChecklistV2ReportParameterFilter, auditMode: boolean) {
        const url = `Checklist/Checklist2ReportOpenChecklists/GetOpenChecklistsSummary?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<IChecklist2ReportChecklistSummary[]>(url, currentFilter),
        );
    }

    getChecklistUnits(currentFilter: IChecklistV2ReportParameterFilter, auditMode: boolean) {
        const url = `Checklist/Checklist2ReportOpenChecklists/GetChecklistUnits?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<IChecklist2ReportChecklistUnits[]>(url, currentFilter),
        );
    }

    getChecklistUnitIds(currentFilter: IChecklistV2ReportParameterFilter, auditMode: boolean) {
        const url = `Checklist/Checklist2ReportOpenChecklists/GetChecklistUnitIds?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<number[]>(url, currentFilter));
    }

    /*getChecklistAnswerDetails(currentFilter: IChecklistV2ReportParameterFilter, auditMode: boolean) {
        const url = `Checklist/Checklist2ReportOpenChecklists/GetChecklistAnswerDetails?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<IChecklist2ReportAnswer[]>(url, currentFilter));
    }*/

    getCheckpoints(currentFilter: IChecklistV2ReportParameterFilter, auditMode: boolean) {
        const url = `Checklist/Checklist2ReportOpenChecklists/GetCheckpoints?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<IChecklist2ReportCheckpoints[]>(url, currentFilter),
        );
    }

    getDeviationsSummary(currentFilter: IChecklistV2ReportParameterFilter, auditMode: boolean) {
        const url = `Checklist/Checklist2ReportOpenChecklists/GetDeviationsSummary?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<IChecklist2ReportAttentionRequired[]>(url, currentFilter),
        );
    }

    getDeviationDetails(currentFilter: IChecklistV2ReportParameterFilter, auditMode: boolean) {
        const url = `Checklist/Checklist2ReportOpenChecklists/GetDeviationDetails?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<IChecklist2ReportAnswer[]>(url, currentFilter));
    }
}
